import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Home = () => {
  const { isAuthenticated, isLoading } = useAuth();

  return (
    <>
      <div className="scientia-container">
        <div className="home-container">
          <div className="hero-section">
            <div className="hero-content">
              <h1 className="hero-title">Welcome to Scientia</h1>
              <p className="hero-subtitle">
                Your personal AI assistant that learns and adapts to your needs.
              </p>

              <div className="hero-buttons">
                {isLoading ? (
                  <div className="loading-indicator">Loading...</div>
                ) : isAuthenticated ? (
                  <Link to="/chat" className="button is-primary">
                    Begin Chat
                  </Link>
                ) : (
                  <>
                    <Link to="/auth/signup" className="button is-primary">
                      Get Started
                    </Link>
                    <Link to="/auth/login" className="button is-outlined">
                      Sign In
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="features-section">
            <div className="container">
              <div className="features-grid">
                <div className="feature-card">
                  <h3>Personalized Learning</h3>
                  <p>Scientia learns about you through conversations and adapts to your preferences.</p>
                </div>
                <div className="feature-card">
                  <h3>Daily Insights</h3>
                  <p>Receive personalized daily messages with weather, calendar data, and research.</p>
                </div>
                <div className="feature-card">
                  <h3>Smart Conversations</h3>
                  <p>Ask questions and get intelligent responses based on your context.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <footer className="home-footer">
        <div className="footer-content">
          <div className="footer-info">
            <p className="footer-text">
              <i><strong>Scientia</strong></i> is the personal project of{' '}
              <Link to="/tyler-triggs" className="footer-link">
                Tyler Triggs,
              </Link>
            </p>
            <p>
              a Product-minded Senior Software Engineer based in Chicago, IL.
            </p>
          </div>
          <div className="footer-links">
            <a
              aria-label="Tyler's GitHub"
              className="footer-social-link"
              href="https://github.com/ttriggs"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                alt="GitHub"
                className="footer-icon-img"
                src="/static/img/github-mark-white.png"
              />
            </a>
            <a
              aria-label="Tyler's LinkedIn"
              className="footer-social-link"
              href="https://www.linkedin.com/in/tylertriggs/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                alt="LinkedIn"
                className="footer-icon-img"
                src="/static/img/linkedInBug-White.png"
              />
            </a>
            <a
              aria-label="Tyler's Musical Project, Vivifluent"
              className="footer-social-link"
              href="http://vivifluent.bandcamp.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                alt="Bandcamp"
                className="footer-icon-img"
                src="/static/img/bandcamp-logotype-light-64.png"
              />
            </a>
            <a
              aria-label="Tyler's Blog"
              className="footer-social-link"
              href="http://tylertriggs.wordpress.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                alt="WordPress"
                className="footer-icon-img"
                src="/static/img/WordPress-logo.png"
              />
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Home;
